module.exports = __webpack_public_path__ + "static/media/18ECA2.4ec7b20f.jpg";